import { jsx as _jsx } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";
import { AnimatedBanner } from "@faire/retailer/components/AnimatedBanner/AnimatedBanner";
import { useFaireDirectMarketplaceIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectMarketplaceIncentive/useFaireDirectMarketplaceIncentive";
import { useFaireDirectFirstOrderIncentiveBanners } from "./__internal__/useFaireDirectFirstOrderIncentiveBanners";
import { FaireDirectMarketplaceIncentiveBanner } from "./FaireDirectMarketplaceIncentiveBanner/FaireDirectMarketplaceIncentiveBanner";
export var FaireDirectIncentivesBanner = function() {
    var _useFaireDirectMarketplaceIncentive = useFaireDirectMarketplaceIncentive(), hasMarketplaceIncentive = _useFaireDirectMarketplaceIncentive.hasIncentive;
    var FIRST_ORDER_INCENTIVE_BANNERS = useFaireDirectFirstOrderIncentiveBanners();
    if (hasMarketplaceIncentive) {
        return /*#__PURE__*/ _jsx(BannerWrapper, {
            children: /*#__PURE__*/ _jsx(FaireDirectMarketplaceIncentiveBanner, {})
        });
    }
    return /*#__PURE__*/ _jsx(StyledAnimatedBanner, {
        banners: Object.values(FIRST_ORDER_INCENTIVE_BANNERS),
        bannerNames: Object.keys(FIRST_ORDER_INCENTIVE_BANNERS)
    });
};
var StyledAnimatedBanner = styled(AnimatedBanner).withConfig({
    componentId: "sc-7e5518bd-0"
})([
    "background-color:",
    ";"
], Decorative.tint.neutral);
var BannerWrapper = styled.div.withConfig({
    componentId: "sc-7e5518bd-1"
})([
    "padding:",
    ";background-color:",
    ";"
], getSpacing("1x"), Decorative.tint.neutral);
